import { pathJoin } from 'src/reducers/routing/utils'

export const createDraftDetailRoutesMap = (prefix: string) => ({
  information: pathJoin(prefix)('information').chain,
})
